import React from "react";
import {
  Box,
  Container,
  Stack,
  SimpleGrid,
  Text,
  Link,
  useColorModeValue,
  Heading,
  VStack,
  Icon,
  Flex,
  Divider,
  Wrap,
  WrapItem,
  Image,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import {
  FaFacebook,
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaExternalLinkAlt,
} from "react-icons/fa";
import NTPLogo from "ntp-logo-react";

const ListHeader = ({ children }) => {
  return (
    <Text
      fontWeight="500"
      fontSize="lg"
      mb={2}
      color={useColorModeValue("gray.700", "gray.200")}
    >
      {children}
    </Text>
  );
};

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Divider />
      <Box
        bg={useColorModeValue("gray.50", "gray.900")}
        color={useColorModeValue("gray.700", "gray.200")}
      >
        <Container as={Stack} maxW={"7xl"} py={10}>
          <SimpleGrid
            templateColumns={{ sm: "1fr 1fr", md: "2fr 1fr 1fr 1fr" }}
            spacing={8}
          >
            {/* Company Info */}
            <Stack spacing={6}>
              <Heading
                fontSize={"2xl"}
                bgGradient="linear(to-r, black, red.500)"
                bgClip="text"
              >
                TRAVEL TIME
              </Heading>
              <Text fontSize={"md"} maxW={"400px"}>
                Travel Time - a trusted company in Corporate and B2B Travel
                Solutions - has built its reputation by consistently delivering
                excellence. Guided by a customer-centric philosophy and powered
                by innovative technology, Travel Time is shaping the future of
                Corporate Travel Management.
              </Text>
              <HStack spacing={4}>
                <IconButton
                  aria-label="Facebook"
                  icon={<FaFacebook />}
                  size="lg"
                  color={"white"}
                  bg={"facebook.400"}
                  _hover={{ bg: "facebook.500" }}
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/traveltimeromania",
                      "_blank",
                    )
                  }
                />
                <IconButton
                  aria-label="Instagram"
                  icon={<FaInstagram />}
                  size="lg"
                  color={"white"}
                  bg={"pink.400"}
                  _hover={{ bg: "pink.500" }}
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/traveltime.ro/",
                      "_blank",
                    )
                  }
                />
              </HStack>
            </Stack>

            {/* Contact Info */}
            <Stack align={"flex-start"}>
              <ListHeader>Contact</ListHeader>
              <HStack>
                <Icon as={FaMapMarkerAlt} color="teal.400" />
                <Text fontSize="md">
                  Popa Tatu Street, No. 49, Sector 1, Bucharest
                </Text>
              </HStack>
              <HStack>
                <Icon as={FaEnvelope} color="teal.400" />
                <Link href="mailto:parteneri@travel-time.ro" fontSize="md">
                  parteneri@travel-time.ro
                </Link>
              </HStack>
              <HStack>
                <Icon as={FaPhone} color="teal.400" />
                <Link href="tel:+40 371121272" fontSize="md">
                  +40371121272
                </Link>
              </HStack>
            </Stack>

            {/* Useful Links */}
            <Stack align={"flex-start"}>
              <ListHeader>Useful Links</ListHeader>
              <Link href="/agentii-partenere" onClick={scrollToTop}>
                Partner Agencies
              </Link>
              <Link href="/servicii" onClick={scrollToTop}>
                Services
              </Link>
              <Link href="/consultanta" onClick={scrollToTop}>
                Consultancy
              </Link>
              <Link href="/contact" onClick={scrollToTop}>
                Contact
              </Link>
              {/* <Link href="/termenisiconditii" onClick={scrollToTop}>
                Termeni si Conditii
              </Link> */}
            </Stack>

            {/* Company Details */}
            <Stack align={"flex-start"}>
              <ListHeader>Identification Data</ListHeader>
              <Text fontSize="sm">SC TRAVEL TIME D&R SRL</Text>
              <Text fontSize="sm">CIF: RO17926970</Text>
              <Text fontSize="sm">Nr. Reg. Com.: J40/15226/2005</Text>

              {/* Logos Section */}
              <VStack spacing={4} align="start" mt={4}>
                {/* First row of logos */}
                <HStack spacing={4}>
                  <Image src="../images/iata.png" alt="IATA" h="35px" />
                  <Image src="../images/anat.png" alt="ANAT" h="35px" />
                  <Image
                    src="../images/logo-travelnation.png"
                    alt="tRAVEL NATION"
                    h="35px"
                  />
                </HStack>

                {/* NTP Logo */}
                <Box w="full">
                  <NTPLogo
                    color="#74deec"
                    version="orizontal"
                    secret="136590"
                  />
                </Box>

                {/* SOL and SAL logos */}
                <Flex justify="center" gap={4} w="full" flexWrap="wrap">
                  <Link
                    href="https://consumer-redress.ec.europa.eu/index_en"
                    isExternal
                    _hover={{ opacity: 0.8 }}
                  >
                    <Image
                      src="../images/SOL.png"
                      alt="SOL Logo"
                      w="140px"
                      h="35px"
                    />
                  </Link>
                  <Link
                    href="https://reclamatiisal.anpc.ro/"
                    isExternal
                    _hover={{ opacity: 0.8 }}
                  >
                    <Image
                      src="../images/SAL.png"
                      alt="SAL Logo"
                      w="140px"
                      h="40px"
                    />
                  </Link>
                </Flex>
              </VStack>
            </Stack>
          </SimpleGrid>
        </Container>

        <Divider />

        <Box py={6} bg={useColorModeValue("gray.100", "gray.800")}>
          <Container maxW={"7xl"}>
            <VStack spacing={4}>
              {/* Documents Links */}
              <Wrap justify="center" spacing={3} px={4}>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat%20lansare%20proiect%20ECOSTART%20312794.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Lansare proiect - 312794 - Ecostart
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat%20lansare%20proiect%20ID%20312355%20-%20CREATE.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Lansare proiect - 312355 - Create
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat de Presa_inchidere Proiect 131118 - Practic-On.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Finalizare proiect - 131118 -
                    Practic-On
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat de Presa_MFE 131117_inchidere proiect - Spots.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Finalizare proiect - 131117 - Spots
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat-lansare-proiect - 133306 - Young Pro.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Lansare proiect - 133306 - Young Pro
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat-inchidere-proiect - 133306 - Young Pro.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Finalizare proiect - 133306 - Young Pro
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>
                  <Link
                    href="/create"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    C.R.E.A.T.E
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
              </Wrap>
            </VStack>
          </Container>
        </Box>

        <Divider />

        {/* Bottom Bar */}
        <Box py={6} bg={useColorModeValue("gray.100", "gray.800")}>
          <Container maxW={"7xl"}>
            <VStack spacing={4}>
              {/* Documents Links */}
              <Wrap justify="center" spacing={3} px={4}>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Licenta%20turism%20TRAVEL%20TIME%20D&R%20-%202026.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Tourism License: 236/ 28.04.2026
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Certificat%20IATA%202026.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    IATA Certification
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/CUI-martie%202026%20-%20TRAVEL%20TIME.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Business Registration Certificate
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/BREVET%20Turism.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Tourism Certification
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Polita%20insolvabilitate%20TRAVEL%20TIME%20D&R.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Insurance Policy
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/ISO%209001%20TRAVEL%20TIME%20DR%20SRL.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    ISO Certificate 9001:2015
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
              </Wrap>

              {/* Second Row of Links */}
              <Wrap justify="center" spacing={3} px={4}>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/ISO14001 TRAVEL TIME DR SRL.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    ISO Certificate 14001:2015
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Draft%20Contract%20Turist.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Tourist Contract
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://anpc.ro/"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    ANPC
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://legislatie.just.ro/Public/DetaliiDocument/257649"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Mandatory ANPC Measures
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Termeni%20si%20conditii%20TT.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Terms and Conditions
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Politica GDPR TT.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    GDPR
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Politica Cookies TT.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Cookies Policy
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
              </Wrap>

              {/* Copyright */}
              <Text
                pt={4}
                fontSize="sm"
                textAlign="center"
                color={useColorModeValue("gray.600", "gray.400")}
              >
                © {new Date().getFullYear()} Travel Time D&R. All rights
                reserved.
              </Text>
            </VStack>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
